// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/download-tdg-document-request-schema',
  type: 'object',
  required: ['externalId'],
  properties: {
    externalId: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
